import { ACTIONS } from '../actions';

export const filteredEmergenciesReducer = (state = [], action) => {
    switch (action.type) {
        case ACTIONS.SET_FILTERED_EMERGENCIES:
            return [...action.payload];
        default:
            return state;
    }
};
